module.exports = __webpack_public_path__ + "img/pdf.10595e21.svg";